import { RequestHookParams, useRequest } from 'src/shared/api';
import { apiRoutesMap } from 'src/shared/config';

import { PriceTraceResponse } from './model';

export interface PriceTraceVariables {
  outlet: string;
  product: number | string;
  warehouse?: string;
}

export const usePriceTrace = (params: RequestHookParams<PriceTraceVariables>) =>
  useRequest<PriceTraceResponse>(apiRoutesMap.priceTrace.getRoute(), params);
